import { render, staticRenderFns } from "./TextCell.vue?vue&type=template&id=f2463736&"
import script from "./TextCell.vue?vue&type=script&lang=ts&"
export * from "./TextCell.vue?vue&type=script&lang=ts&"
import style0 from "./TextCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports